export type TLocalStorageKeys = 'supportTicketFilters' | 'supportTicketSorting' | 'analyticsTableFilters' | 'appTheme';

export const setLocalStorageItem = (key: TLocalStorageKeys, value: any): void => {
    let storageValue: string = '';
    if (typeof value === 'object') {
        storageValue = JSON.stringify(value);
    } else {
        storageValue = value;
    }

    localStorage.setItem(key, storageValue);
}

export const getLocalStorageItem = <T>(key: TLocalStorageKeys): T => {
    const localItem = localStorage.getItem(key);
    if (!localItem) {
        return null;
    }

    try {
        return JSON.parse(localItem) as T;
    } catch {
        return localItem as T;
    }
}

export const removeLocalStorageItem = (key: TLocalStorageKeys): void => {
    localStorage.removeItem(key);
};

export const clearLocalStorage = (): void => {
    localStorage.clear();
}